import React from "react";

export const ReportFrame = React.memo(({ url }) => {
  if (!url) return null;

  return (
    <iframe
      src={url}
      width="100%"
      height="600"
      frameBorder="0"
      style={{ marginTop: "30px", borderRadius: "8px" }}
      title="Metabase Report"
    />
  );
});